import React from 'react';
import GenericTable from '../../common/GenericTable';

const PAGE_SIZE_STORAGE_KEY = 'bulkImportWizard.itemsPerPage';
const DEFAULT_PAGE_SIZE = 20;

/**
 * Paginated rows of a bulk import preview or result, built on the system's
 * GenericTable (20 rows per page by default, page size selector in the footer).
 * `columns` is [{ key, label, align?, width?, render(row) }].
 */
const ImportPreviewTable = ({ rows, columns, getRowId, getRowStyle, emptyMessage = 'Sin filas' }) => (
  <div style={{ flex: 1, minHeight: 0, overflow: 'auto', border: '1px solid #eee', borderRadius: 8, padding: '0 8px' }}>
    <GenericTable
      showCheckbox={false}
      rowClickable={false}
      data={rows}
      getRowId={getRowId}
      getRowStyle={getRowStyle}
      emptyMessage={emptyMessage}
      defaultItemsPerPage={DEFAULT_PAGE_SIZE}
      pageSizeStorageKey={PAGE_SIZE_STORAGE_KEY}
      tableStyle={{ margin: '8px 0' }}
      columnsConfig={columns.map((column) => ({
        key: column.key,
        label: column.label,
        width: column.width,
        sortable: false,
        accessor: (row) => row,
        render: (_, row) => (
          <div style={{ textAlign: column.align || 'left' }}>{column.render(row)}</div>
        ),
      }))}
    />
  </div>
);

export default ImportPreviewTable;
